import {
    ACTIVATED,
    ADDITIONAL_STATUS,
    BATCH_STATUS,
    CARD_CONFIG_STATUS,
    CONTRACT,
    CREATED_STATUS,
    DEBIT_CARD,
    DEBIT_CARD_PIN,
    DEPOSIT_CONFIG_STATUS,
    DOCUMENTATION,
    FIOC,
    IDENTIFICATION,
    IDENTIFICATION_ROBO,
    IDENTIFIED,
    IDENTIFIED_ROBO,
    JAFFAR_STATUS,
    LIMIT_CREDIT,
    PENDING_OTP,
    PRE_DOCUMENTATION,
    READY_STATUS,
    REGISTER_STATUS,
    SIGNATURE_KEY,
    SIGNED,
    SIMULATION_STATUS,
    STAND_BY,
    SUCCESS,
    SUITABILITY_TEST_STATUS,
    TRANSFER_OTP,
    UPDATING_DOCUMENTATION_STATUS,
    WAITING,
} from 'constants/statusProcess';
import {
    CONFIG_CARD_VIEW,
    CREDIT_CARD_VIEW,
    DEPOSIT_VIEW,
    DOCUMENTATION_VIEW,
    IDENTIFICATION_VIEW,
    INVESTMENT_PLAN_VIEW,
    OTP_TRANSFER_VIEW,
    PERSONAL_DATA_VIEW,
    PROFESSIONAL_DATA_VIEW,
    SIGNATURE_KEY_VIEW,
    SIGNING_CONTRACT_VIEW,
    SUITABILITY_TEST_VIEW,
} from 'constants/steps';

export const getViewNameByStatus = status => {
    const viewByStatusName = {
        [FIOC]: PROFESSIONAL_DATA_VIEW,
        [PENDING_OTP]: OTP_TRANSFER_VIEW,
        [TRANSFER_OTP]: OTP_TRANSFER_VIEW,
        [DEPOSIT_CONFIG_STATUS]: DEPOSIT_VIEW,
        [SIGNATURE_KEY]: SIGNATURE_KEY_VIEW,
        [CARD_CONFIG_STATUS]: CONFIG_CARD_VIEW,
        [BATCH_STATUS]: PROFESSIONAL_DATA_VIEW,
        [JAFFAR_STATUS]: PROFESSIONAL_DATA_VIEW,
        [WAITING]: PROFESSIONAL_DATA_VIEW,
        [READY_STATUS]: PROFESSIONAL_DATA_VIEW,
        [DEBIT_CARD]: PROFESSIONAL_DATA_VIEW,
        [DEBIT_CARD_PIN]: PROFESSIONAL_DATA_VIEW,
        [IDENTIFICATION_ROBO]: IDENTIFICATION_VIEW,
        [IDENTIFIED_ROBO]: IDENTIFICATION_VIEW,
        [IDENTIFICATION]: IDENTIFICATION_VIEW,
        [CREATED_STATUS]: IDENTIFICATION_VIEW,
        [IDENTIFIED]: SIGNATURE_KEY_VIEW,
        [CONTRACT]: SIGNING_CONTRACT_VIEW,
        [SIGNED]: SIGNING_CONTRACT_VIEW,
        [PRE_DOCUMENTATION]: DOCUMENTATION_VIEW,
        [UPDATING_DOCUMENTATION_STATUS]: DOCUMENTATION_VIEW,
        [DOCUMENTATION]: DOCUMENTATION_VIEW,
        [STAND_BY]: DOCUMENTATION_VIEW,
        [SUCCESS]: OTP_TRANSFER_VIEW,
        [ACTIVATED]: OTP_TRANSFER_VIEW,
        [REGISTER_STATUS]: PERSONAL_DATA_VIEW,
        [SUITABILITY_TEST_STATUS]: SUITABILITY_TEST_VIEW,
        [ADDITIONAL_STATUS]: PERSONAL_DATA_VIEW,
        [LIMIT_CREDIT]: CREDIT_CARD_VIEW,
        [SIMULATION_STATUS]: INVESTMENT_PLAN_VIEW,
    };

    return viewByStatusName[status];
};
